import React from "react";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {NodeType} from "../../../../../model/ModelData";
import {fieldSx} from "../editMenuStyles";
import {SubSectionHeader, ToggleRow} from "../components/EditMenuSection";

export const ConfirmationSettings = ({node, project, onUpdate, onChangeData, nodes}) => {
    const items = nodes.filter(item => node?.id !== item.id && [NodeType.QA].includes(item.type));

    return (
        <>
            <SubSectionHeader title="Confirmation"/>

            <ToggleRow
                control="checkbox"
                label="Confirm"
                checked={node?.data?.confirmation}
                onChange={(e) => onChangeData("confirmation", e.target.checked)}
                onBlur={() => onUpdate(node)}
            />

            <TextField
                value={node?.data?.confirmation_message}
                disabled={!node?.data?.confirmation}
                size="small"
                label="Confirmation message"
                placeholder="Write message"
                helperText="Ask for confirmation"
                sx={fieldSx}
                onChange={(e) => onChangeData("confirmation_message", e.target.value)}
                onBlur={() => onUpdate(node)}
            />
            <TextField
                value={node?.data?.confirmation_params?.join(", ") || ""}
                disabled={!node?.data?.confirmation}
                size="small"
                label="Confirmation parameters"
                placeholder="Write parameters"
                helperText="Write new param with (,)"
                sx={fieldSx}
                onChange={(e) => onChangeData("confirmation_params", e.target.value?.replaceAll(", ", ",").split(","))}
                onBlur={() => onUpdate(node)}
            />

            <ToggleRow
                control="checkbox"
                label="Inherit 'no_match' route from parent"
                checked={node?.data?.qa_inherit_from_parent}
                onChange={(e) => {
                    onChangeData("qa_inherit_from_parent", e.target.checked);
                    if (e.target.checked) {
                        onChangeData("confirmation_no_match", null);
                    }
                }}
                onBlur={() => onUpdate(node)}
            />

            <FormControl
                size="small"
                fullWidth
                sx={fieldSx}
                disabled={!node?.data?.confirmation || node?.data?.qa_inherit_from_parent}
            >
                <InputLabel id="confirmation-no-match-label">Confirmation No-Match route</InputLabel>
                <Select
                    labelId="confirmation-no-match-label"
                    value={node?.data?.confirmation_no_match || null}
                    label="Confirmation No-Match route"
                    onBlur={() => onUpdate(node)}
                    onChange={(e) => onChangeData("confirmation_no_match", e.target.value)}
                >
                    <MenuItem value={null}><em>None</em></MenuItem>
                    {items.map(n => (
                        <MenuItem key={n?.id} value={n?.id}>{n?.name || n?.id}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
};
